const navbar = () => {
  $(() => {

    $("body").on("click", ".menu-item .material-symbols-outlined", function () {
      $(this).next(".dropdown-menu").toggleClass("d-none");
    });

    if ($(window).width() > 990) {
      $("body").on("mouseenter", ".dropdown", function () {
        $(this).find(".dropdown-menu").removeClass("d-none");
      });
      $("body").on("mouseleave", ".dropdown", function () {
        $(this).find(".dropdown-menu").addClass("d-none");
      });
    }

    const navbarToggler = document.querySelector(".navbar-toggler");
    if (navbarToggler) {
      navbarToggler.addEventListener("click", () => {
        navbarToggler.classList.toggle("collapsed");
        $("#navbarToggler").toggleClass("aperto");
        $("body").toggleClass("noscroll");
      });
    }

    const heroOffset = $(".hero__section").offset()
      ? $(".hero__section").offset().top
      : 0;

    const stickedTrigger = heroOffset;
    const hysteresis = 20;

    const handleScroll = () => {
      const scroll = $(window).scrollTop();

      // stickyHeader
      $("body").toggleClass("stickyHeader", scroll > 0);

      // sticked
      if (scroll > stickedTrigger + hysteresis) {
        $("body").addClass("sticked");
      } else if (scroll <= stickedTrigger) {
        $("body").removeClass("sticked");
      }
    };

     // run once on load
    handleScroll();

     // run on scroll
    $(window).on("scroll", handleScroll);
  });
};

export default navbar;
